(()=>{
    const urlParams = new URLSearchParams(window.location.search);
    const sunniesParam = urlParams.get("utm_sunnies");
    if(!sunniesParam || sunniesParam != "true") return;

    const FREE_SUNNIES_VARIANT_ID = 42857359474749;
    const FREE_SUNNIES_PROPERTY = "_free-sunnies";

    const atcFunc = async () => {

        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        const alreadyAdded = cart.items.some(lineItem =>
            lineItem.id === FREE_SUNNIES_VARIANT_ID ||
            (lineItem.properties && lineItem.properties[FREE_SUNNIES_PROPERTY])
        );

        if(alreadyAdded) return;

        const data = {
            quantity: 1,
            id: FREE_SUNNIES_VARIANT_ID,
            properties: {
                [FREE_SUNNIES_PROPERTY]: "asfadgaef"
            }
        };

        await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

    }

    atcFunc();

})()